import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import {
  MdDashboard,
  MdDocumentScanner,
  MdSupervisorAccount,
  MdSettingsApplications,
  MdOutlineClose,
  MdLogout,
  MdOutlineReportProblem,
  MdOutlineRequestQuote,
  MdMeetingRoom,
  MdShare,
  MdFolder,
} from "react-icons/md";
import { FaRegBuilding, FaUsers } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import logo from "../../../../assets/logo.svg";
// import logo from "../../../../assets/logo.svg";
import Footer from "../../../Footer/Footer";
import { getTokenData, logout } from "../../../../services/Auth__Service";
import AuthContext from "../../../Context/AuthContext";

const Header = () => {
  const { setIsAuthentificated } = useContext(AuthContext);

  const hideMenu = () => {
    document.querySelector(".header").classList.remove("show");
  };

  return (
    <div className="header">
      <div className="header-header">
        <img src={logo} alt="logo" className="header__logo" />
        <MdOutlineClose className="header-close" onClick={hideMenu} />
      </div>
      {/* <hr /> */}
      <div className="menu__items">
        <NavLink
          to="/main/dashboard"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdDashboard />
          Accueil
        </NavLink>
        <NavLink
          to="/main/client"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <FaRegBuilding />
          Clients
        </NavLink>
        <NavLink
          to="/main/salarie"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdSupervisorAccount />
          Salariés
        </NavLink>
        <NavLink
          to="/main/docpaie"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdShare />
          Docs. Paie
        </NavLink>
        <NavLink
          to="/main/document"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdDocumentScanner />
          Bulletins
        </NavLink>
        <NavLink
          to="/main/docrh"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdFolder />
          Docs. RH
        </NavLink>
        <NavLink
          to="/main/simulation"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdOutlineRequestQuote />
          Simulations
        </NavLink>
        <NavLink
          to="/main/meeting"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdMeetingRoom />
          Réunions
        </NavLink>

        <NavLink
          to="/main/users"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <FaUsers />
          Utilisateurs
        </NavLink>

        <NavLink
          to="/main/logs"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <MdOutlineReportProblem />
          Logs
        </NavLink>
        <NavLink
          to="/main/profil"
          className="menu__item"
          activeclassname="active"
          onClick={hideMenu}
        >
          <CgProfile />
          Profil
        </NavLink>
      </div>
      <div className="logout">
        <div
          className="logout__content"
          onClick={() => {
            logout();
            setIsAuthentificated(false);
          }}
        >
          <MdLogout
            style={{
              transform: "rotate(180deg)",
              marginRight: "10px",
            }}
          />
          Déconnexion
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Header;
